<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>UPDATE ITEM</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <!-- Product Image -->
        <template v-if="dataImg">

          <!-- Image Container -->
          <!-- <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataImg" alt="img" class="responsive">
          </div> -->

          <!-- Image upload Buttons -->
          <!-- <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Update Image</vs-button>
            <vs-button type="flat" color="#999" @click="dataImg = null">Remove Image</vs-button>
          </div> -->
        </template>

        <!-- NAME -->
        <vs-input label="Name" v-model="dataName" class="mt-5 w-full" name="item-name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>

        <!-- CATEGORY -->
        <vs-select v-model="dataCategory" label="Category" class="mt-5 w-full" name="item-category" v-validate="'required'">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in category_choices" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-category')">{{ errors.first('item-category') }}</span>

        <!-- STATUS -->
        <!-- <vs-select v-model="dataOrder_status" label="Status" class="mt-5 w-full">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in order_status_choices" />
        </vs-select> -->

         <!-- SKU -->
        <vs-input label="SKU" v-model="dataSku" class="mt-5 w-full" name="item-sku" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-sku')">{{ errors.first('item-sku') }}</span>


         <!-- INCOMING
        <vs-input label="Incoming" v-model="dataIncoming" class="mt-5 w-full" name="item-incoming" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-incoming')">{{ errors.first('item-incoming') }}</span> -->

        
        <!-- AVAILABLE quantity -->
        <vs-input label="Available" v-model="dataAvailable" class="mt-5 w-full" name="item-available" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-available')">{{ errors.first('item-available') }}</span>

        <!-- Estimated Ship time -->
        <vs-input label="Estimated Ship Time" v-model="dataShipTime" class="mt-5 w-full" name="item-shipTime" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-shipTime')">{{ errors.first('item-shipTime') }}</span>

         <!-- PRICE -->
        <!-- <vs-input
          label="Price"
          v-model="dataPrice"
          class="mt-5 w-full"
          name="item-price" />
        <span class="text-danger text-sm" v-show="errors.has('item-price')">{{ errors.first('item-price') }}</span> -->


         <!-- COLOR -->  
        <vs-input label="Color" v-model="dataColor" class="mt-5 w-full" name="item-color" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-color')">{{ errors.first('item-color') }}</span>


         <!-- ESTIMATED SHIP TIME -->
        <vs-input label="Estimated Ship Time" v-model="dataShipTime" class="mt-5 w-full" name="item-shipTime" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-shipTime')">{{ errors.first('item-shipTime') }}</span>


         <!-- MAX_BUYABLE_QTY -->
        <vs-input label="Max Buyable Qty" v-model="dataMaxBuyableQty" class="mt-5 w-full" name="item-maxBuyableQty" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-maxBuyableQty')">{{ errors.first('item-maxBuyableQty') }}</span>

         <!-- SIZE -->
        <vs-input label="Size" v-model="dataSize" class="mt-5 w-full" name="item-size" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-size')">{{ errors.first('item-size') }}</span>

         <!-- HEIGHT -->
        <vs-input label="Height" v-model="dataHeight" class="mt-5 w-full" name="item-height" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-height')">{{ errors.first('item-height') }}</span>

         <!-- LENGTH -->
        <vs-input label="Length" v-model="dataLength" class="mt-5 w-full" name="item-length" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-length')">{{ errors.first('item-length') }}</span>

         <!-- WEIGHT -->
        <vs-input label="Weight" v-model="dataWeight" class="mt-5 w-full" name="item-weight" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-weight')">{{ errors.first('item-weight') }}</span>

         <!-- WIDTH -->
        <vs-input label="Width" v-model="dataWidth" class="mt-5 w-full" name="item-width" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-width')">{{ errors.first('item-width') }}</span>
        
        <!-- Upload -->
        <!-- <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" /> -->

        <!-- <div class="upload-img mt-5" v-if="!dataImg">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button @click="$refs.uploadImgInput.click()">Upload Image</vs-button>
        </div> -->
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {

      dataId: null,
      dataName: '',
      dataCategory: null,
      dataImg: null,
      dataPrice: 0,
      uplaodedFile: null,

      dataSku : null,
      dataIncoming : null,
      dataAvailable : 0,
      dataColor : null,
      dataShipTime : null,
      dataMaxBuyableQty : 0,
      dataSize : null,
      dataHeight : 0,
      dataLength : 0,
      dataWeight : 0,
      dataWidth : 0,

      category_choices: [
        {text:'Micro Controller Kitwww', value:'Micro Controller Kitwww'},
        {text:'Micro Controller Kit', value:'Micro Controller Kit'}
      ],

      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { category, id, largeImgUrl, name, priceAmount, sku, incoming, qty, color, estimateShipTime, maxBuyableQty, size, height, length, weight, width } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataCategory = category
        this.dataImg = largeImgUrl
        this.dataName = name
        this.dataPrice = priceAmount

        this.dataSku = sku
        this.dataIncoming = incoming
        this.dataAvailable = qty
        this.dataColor = color
        this.dataShipTime = estimateShipTime
        this.dataMaxBuyableQty = maxBuyableQty
        this.dataSize = size
        this.dataHeight = height
        this.dataLength = length
        this.dataWeight = weight
        this.dataWidth = width

        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataName && this.dataCategory && this.dataPrice > 0
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = ''
      this.dataCategory = null
      this.dataPrice = 0
      this.dataImg = null

      this.dataSku = null
      this.dataIncoming = null
      this.dataAvailable = 0
      this.dataColor = null
      this.dataShipTime = null
      this.dataMaxBuyableQty = 0
      this.dataSize = null
      this.dataHeight = 0
      this.dataLength = 0
      this.dataWeight = 0
      this.dataWidth = 0
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.dataId,
            name: this.dataName,
            // largeImgUrl: this.dataImg,
            category: this.dataCategory,
            priceAmount: this.dataPrice,

            sku : this.dataSku,
            incoming : this.dataIncoming,
            qty : this.dataAvailable,
            color : this.dataColor,
            estimateShipTime : this.dataShipTime,
            maxBuyableQty : this.dataMaxBuyableQty,
            size : this.dataSize,
            height : this.dataHeight,
            length : this.dataLength,
            weight : this.dataWeight,
            width : this.dataWidth
          }
          // console.log('object', obj.id)
          if (this.dataId !== null) { // removed this condition here --> && this.dataId >= 0
            this.$store.dispatch('products/updateInventry', obj)
              .then(response => {
                console.log(response.data.data)
                this.successMsg('Inventory updated')
              })
              .catch((err) => {
                console.error(err)
                this.errorMsg(err)
              })
          } 
          // else {
          //   delete obj.id
          //   //obj.popularity = 0
          //   // obj.largeImgUrl = 'image_url'
          //   this.$store.dispatch('products/addProduct', obj).catch(err => { console.error(err) })
          // }

          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    },
    successMsg (message) {
      this.$vs.notify({
        title: 'Success',
        text: message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    errorMsg (errMsg) {
      this.$vs.notify({
        title: 'Failed',
        text: errMsg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })
    }
    // updateCurrImg (input) {
    //   console.log('image input', input.target.files[0])
    //   if (input.target.files && input.target.files[0]) {
    //     const reader = new FileReader()
    //     this.dataImg = input.target.files[0]
    //     reader.onload = e => {
    //       this.uplaodedFile = e.target.result
    //     }
    //     reader.readAsDataURL(input.target.files[0])
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
